import Repository from "@/services/api/Repository";


const resource = "/admin";
export default {
    getUser(params) {
        let response = {
            'status': 'null',
            'data': null
        }

        return Repository.get(`${resource}/users`, params)
            .then(res => {
                console.log(res)
                if (res.status !== 200) {
                    response.data = 'Received Status ' + response.status + ' From the API'
                    response.status = 'error'
                    return response
                }

                response.data = res.data;
                response.status = 'success';
                return response;
            })
            .catch(function (error) {
                if (error.response) {
                    // Request made and server responded
                    response.status = 'error';
                    response.data = error.response.data.description;
                    return response;
                } else if (error.request) {
                    response.status = 'error';
                    response.data = 'Problem reaching search API';
                    return response
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }
            })
    },

}